export default "//yastatic.net/s3/distribution/pythia/frontend/_/ee988421add6be9bb50f3726ca3248a7.png";